import React from 'react';

const METRICS = [
  'BRECHA INICIAL',
  'CAPTADOS / AGENDADOS',
  'ASISTENCIA / RESCATES',
  'CASCADAS CON EVIDENCIA DE RESOLUCIÓN',
  'CONTINUIDAD RECUPERADA',
  'TIEMPO A CUMPLIMIENTO',
];

export default function ImplBlock7Metrics() {
  return (
    <>
      <section className="py-24 md:py-24 px-6 md:px-16 bg-surface border-t border-line">
        <div className="max-w-[1280px] mx-auto">
          
          <div className="text-center mb-16 max-w-4xl mx-auto">
            <h2 className="text-[24px] md:text-[32px] lg:text-[48px] font-bold text-ink mb-6 tracking-tight leading-[1.2]">
              La implementación se mide por movimiento de la población, no por usuarios conectados al software.
            </h2>
            <p className="text-[16px] md:text-[20px] text-ink-soft leading-[1.6]">
              El primer resultado de BAC es saber qué población avanzó, qué permanece pendiente y qué debe ocurrir después.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {METRICS.map((label) => (
              <div
                key={label}
                className="border border-line p-8 rounded-xl flex items-center justify-center text-center bg-surface text-ink cursor-default transition-all duration-[500ms] ease-in-out hover:scale-105 hover:bg-[#cff9ff] hover:border-[#28ADFF]/40 hover:text-brand hover:shadow-sm"
              >
                <span className="text-[14px] font-semibold tracking-widest uppercase">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Block */}
      <section className="py-24 md:py-24 px-6 md:px-16 bg-[#efefff] text-ink text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-[32px] md:text-[48px] font-bold mb-6 tracking-tight">
            ¿Qué población de tu red necesita operación?
          </h2>
          <p className="text-[16px] md:text-[20px] text-ink-soft mb-10">
            Conversemos sobre qué población priorizar, qué capacidad existe y qué resultados deberían medirse desde el inicio.
          </p>
          <a href="/#contacto" className="inline-block bg-brand text-white hover:bg-brand-deep hover:text-white px-12 py-3 text-[20px] font-semibold tracking-widest rounded-xl transition-colors uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand">
            CONVERSEMOS
          </a>
        </div>
      </section>
    </>
  );
}
